import { render, staticRenderFns } from "./ViewLetters.vue?vue&type=template&id=d956897c"
import script from "./ViewLetters.vue?vue&type=script&lang=js"
export * from "./ViewLetters.vue?vue&type=script&lang=js"
import style0 from "./ViewLetters.vue?vue&type=style&index=0&id=d956897c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports